import React from "react";
import { UploadResultsContent } from "../components/upload-results/UploadResultsContent";
import { useUploadResultsReport } from "../hooks/useUploadResultsReport";

/**
 * Results page displaying the uploaded campaign report analytics.
 *
 * Supports three view modes:
 * - Original: Continuous scroll layout optimized for web viewing
 * - Slide: PowerPoint-optimized layout with 16:9 slides for export (5 slides)
 * - Compact: Executive 2-slide format with Insight → Analysis → Action framework
 */
export const UploadResultsPage: React.FC = () => {
  const {
    currentReportId,
    reportMetadata,
    data,
    handleNewUpload,
    reportProduct,
    setShowNoticeModal,
    showNoticeModal,
  } = useUploadResultsReport();

  return (
    <UploadResultsContent
      currentReportId={currentReportId}
      data={data}
      reportMetadata={reportMetadata}
      handleNewUpload={handleNewUpload}
      reportProduct={reportProduct}
      setShowNoticeModal={setShowNoticeModal}
      showNoticeModal={showNoticeModal}
      viewMode="original"
    />
  );
};

export const UploadResultsPageWithState: React.FC<{
  viewMode: "original" | "slide" | "compact";
  onViewModeChange: (mode: "original" | "slide" | "compact") => void;
}> = ({ viewMode, onViewModeChange }) => {
  const {
    currentReportId,
    reportMetadata,
    data,
    handleNewUpload,
    reportProduct,
    setShowNoticeModal,
    showNoticeModal,
  } = useUploadResultsReport();

  void onViewModeChange;

  return (
    <UploadResultsContent
      currentReportId={currentReportId}
      data={data}
      reportMetadata={reportMetadata}
      handleNewUpload={handleNewUpload}
      reportProduct={reportProduct}
      setShowNoticeModal={setShowNoticeModal}
      showNoticeModal={showNoticeModal}
      viewMode={viewMode}
    />
  );
};
